import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lighting",
  "use": "lighting-usage",
  "viewBox": "0 0 487 689",
  "content": "<symbol viewBox=\"0 0 487 689\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"lighting\">\r\n\t<path d=\"M486 0L305 371.5H153.171L1 688.876\" stroke=\"#00AEEF\" stroke-width=\"2\" stroke-dasharray=\"1000\" stroke-dashoffset=\"2000\">\r\n\t\t<animate attributeName=\"stroke-dashoffset\" values=\"2000; -2000\" dur=\"10s\" repeatCount=\"indefinite\"></animate>\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol